export default [
  {
    path: '/courses',
    component: () => import('./views/Index'),
    name: 'courses',
    redirect: { name: 'courses-list' },
    children: [
      {
        path: '',
        name: 'courses-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: ':id',
        name: 'courses-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
